import React, { ReactElement, useContext } from "react";
import { ThemeContext, ThemeProvider } from "styled-components";

import { addEditAttributes } from "utils/episerver";

import { StyledButton, StyledLink } from "./Filter.styled";
import FilterProps from "./FilterProps";

const Filter = ({
    linkText,
    to,
    url,
    className,
    children,
    selected,
    disabled,
    onClick,
    noScroll,
}: FilterProps): ReactElement => {
    const themeContext = useContext(ThemeContext);
    const theme = (themeContext && themeContext.theme) || "lightgray";

    return (
        <ThemeProvider theme={{ theme: theme }}>
            {to || url ? (
                <StyledLink
                    className={className}
                    to={to || url}
                    selected={selected}
                    disabled={!selected && disabled}
                    aria-current={selected ? "page" : undefined}
                    noScroll={noScroll}
                    exact
                    onClick={onClick}
                    {...addEditAttributes("Text")}
                >
                    <span>{linkText || children || ""}</span>
                </StyledLink>
            ) : (
                <StyledButton
                    className={className}
                    selected={selected}
                    disabled={!selected && disabled}
                    aria-current={selected ? "page" : undefined}
                    onClick={onClick}
                    {...addEditAttributes("Text")}
                >
                    <span>{linkText || children || ""}</span>
                </StyledButton>
            )}
        </ThemeProvider>
    );
};

export default React.memo(Filter);
